import {Path} from '../../../modules/routing/routes.definition';
import {TEXT} from './Account.definition';

type NavigateTo = {navigateTo: (path: string) => void};

type HandleLogout = {
  logout: () => Promise<void>;
  showError: () => void;
} & NavigateTo;

const handleLogout = async ({logout, navigateTo, showError}: HandleLogout): Promise<void> => {
  try {
    await logout();
    navigateTo(Path.LOGIN);
  } catch (error) {
    showError();
  }
};

const handleOrderCTA = ({navigateTo}: NavigateTo): void => navigateTo(Path.HOME);

type HandleUpdateError = {
  showError: ({message}: {message: string}) => void;
  formatMessage: ({id}: {id: string}) => string;
};

const handleUpdateError = ({showError, formatMessage}: HandleUpdateError): void =>
  showError({message: formatMessage(TEXT.NOTIFICATION_ERROR)});

export {handleLogout, handleOrderCTA, handleUpdateError};
